<template>
  <main v-if="apiReady" class="panels">
    <b-container>
      <b-row>
        <!-- <b-col v-if="!showExploreSidebar" class="p-0"> </b-col> -->
        <b-col class="p-0">
          <TTCTable
            v-if="settings !== null && ttcReady"
            ref="ttcTable"
            :savedMemory="settings"
            :settings="quickSettings"
            @setDefaults="setDefaults"
          ></TTCTable>
        </b-col>
        <!-- <b-col class="p-0"> </b-col> -->
      </b-row>
    </b-container>

    <panelOptions
      v-if="showOptionsPanel"
      :element="activeElement"
      @updateDocPanel="updateDocPanel"
    ></panelOptions>

    <div
      class="container-fluid panel-top"
      :class="{
        opened: showTopPanel,
        //leftopened: showLeftSidebar,
        //rightopened: showExploreSidebar,
        //leftrightopened: showLeftSidebar && showExploreSidebar
      }"
    >
      <b-row>
        <b-col
          ><PanelTop
            v-if="defaults"
            :settings-panel="'StorySettings'"
            :settings="defaults"
            @updateSettings="updateSettings"
            @removeBookmarks="removeBookmarks"
            @clearSorting="clearSorting"
            @resetStory="resetStory"
          ></PanelTop
        ></b-col>
      </b-row>
      <b-row class="panel-switch">
        <b-col class="d-flex justify-content-center">
          <b-btn
            class="btn-top-panel"
            variant="outline"
            @click="toggleTopPanel"
          >
            <i class="fa fa-caret-down" />
          </b-btn>
        </b-col>
      </b-row>
    </div>

    <!-- <div class="left-sidebar-toggle" :class="{ opened: showLeftSidebar }">
      <b-btn variant="outline-secondary" @click="toggleLeftSidebar">
        <i class="fa fa-sliders-h" />
        <span class="ml-2">Focus</span>
      </b-btn>
    </div> -->

    <PanelLeft :class="{ opened: showLeftSidebar }"></PanelLeft>

    <div
      class="container-fluid panel-bottom"
      :class="{
        opened: showDocumentsPanel,
        //leftopened: showLeftSidebar,
        //rightopened: showExploreSidebar,
        //leftrightopened: showLeftSidebar && showExploreSidebar,
        expanded: showDocumentsPanel && panelExpanded === 'expanded',
      }"
    >
      <b-row class="panel-head pt-2 pb-2">
        <b-col class="d-flex align-items-center">
          <p class="text-overflow-ellipsis">
            {{ documentsCount }} documents
            <span class="text-muted">
              filter: {{ filterFocused ? filterFocused.name : "none" }},
              selection: {{ activeElement ? activeElement.name : "none" }}
            </span>
          </p>
        </b-col>
        <b-col class="d-flex justify-content-end align-items-center">
          <b-btn
            v-if="showDocumentsPanel"
            variant="outline-secondary"
            class="mr-1"
            @click="resizeDocumentsPanel"
          >
            <i class="fa fa-expand" />
          </b-btn>
          <b-btn
            v-if="showDocumentsPanel"
            variant="outline-secondary"
            class="mr-1"
            @click="clearDocFilter"
          >
            <i class="fa fa-undo" />
          </b-btn>
          <xlsx-workbook v-if="exportReady" class="btn mr-1 btn-outline-secondary p-0 d-flex">
            <xlsx-sheet :collection="exportData" :sheet-name="'sheet name'" />
            <xlsx-download>
              <b-btn
                variant="white"
                ><i class="fa fa-download"
              /></b-btn>
            </xlsx-download>
          </xlsx-workbook>
          <b-button
            v-else
            class="mr-1"
            @click="exportDocs"
            variant="outline-secondary"
          >
            <b-spinner v-if="docsLoading" small type="grow"></b-spinner>
            {{ docsLoading ? "Downloading Docs" : "Export Docs" }}
          </b-button>
          <b-form-select
            v-model="selectedCollection"
            class="custom-select custom-select-collections mr-1 mb-0"
            :options="options"
            @change="getCollectionDocs"
          ></b-form-select>
          <b-btn variant="primary" @click="toggleDocumentsPanel">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-chevron-double-down"
              viewBox="0 0 16 16"
              v-if="showDocumentsPanel"
            >
              <path
                fill-rule="evenodd"
                d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
              />
              <path
                fill-rule="evenodd"
                d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-chevron-double-up"
              viewBox="0 0 16 16"
              v-else
            >
              <path
                fill-rule="evenodd"
                d="M7.646 2.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 3.707 2.354 9.354a.5.5 0 1 1-.708-.708l6-6z"
              />
              <path
                fill-rule="evenodd"
                d="M7.646 6.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 7.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
              />
            </svg>
            <span class="ml-2">Document panel</span>
          </b-btn>
        </b-col>
      </b-row>
      <b-row class="panel-body">
        <b-col
          ><PanelBottom
            ref="docPanel"
            @resetCollection="resetCollection"
            :selection="activeElement"
          ></PanelBottom
        ></b-col>
      </b-row>
    </div>
    <chatbot @toggleDocumentsPanel="toggleDocumentsPanel" v-if="chatbotState" />
  </main>
</template>

<script>
import _ from "lodash";
import { XlsxDownload, XlsxSheet, XlsxWorkbook } from "vue-xlsx";
import { mapActions, mapState } from "vuex";
import { EventBus } from "@/eventBus";
import DataSettings from "@/helpers/DataSettings";
import InitApi from "../Shared/InitApi";
import PanelBottom from "../Shared/PanelBottom";
import PanelLeft from "../Shared/PanelLeft";
import PanelOptions from "../Shared/PanelOptions";
import PanelTop from "../Shared/PanelTop";
import TTCTable from "./TTCTable";
import Chatbot from '../Chatbot/Chatbot.vue';

export default {
  name: "ExploreStory",
  components: {
    PanelLeft,
    PanelTop,
    PanelBottom,
    PanelOptions,
    TTCTable,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
    Chatbot
  },
  extends: InitApi,
  data() {
    return {
      ttcReady: false,
      activeElement: null,
      showLeftSidebar: false,
      showTopPanel: false,
      showDocumentsPanel: false,
      showOptionsPanel: false,
      quickSettings: {
        color: "recency",
        colorOptions: null,
        sizeRange: [],
        recencyRange: [],
      },
      defaults: null,
      options: [{ value: null, text: "Select Collection" }],
      selectedCollection: null,
      exportReady: false,
      docsLoading: false,
      exportData: [],
    };
  },
  computed: {
    ...mapState({
      apiId: (state) => state.api.apiId,
      apiReady: (state) => state.api.apiReady,
      dataSettings: (state) => state.setting.dataSettings,
      documents: (state) => state.document.documents,
      documentsExport: (state) => state.document.documentsExport,
      documentsCount: (state) => state.document.documentsCount,
      filterFocused: (state) => state.filter.filterFocused,
      panelExpanded: (state) => state.document.documentsPanelState,
      collections: (state) => state.collection.collections,
      chatbotState: (state) => state.chatbot.chatbotState,
      ttcState: (state) => state.layout.ttcState
    }),
    settings(){
      return DataSettings.getSettings("story");
    }
  },
  watch: {
    documents(){
      this.exportReady = false;
      this.docsLoading = false;
    },
    collections() {
      this.setCollections();
      this.exportReady = false;
      this.docsLoading = false;
    },
    selectedCollection() {
      this.exportReady = false;
      this.docsLoading = false;
    },
  },
  mounted() {
    if(!this.ttcState){
      this.loadAnimStart();
      this.saveLoadingStep("Loading TTC.....");
      this.saveTtcState(true).then(() => {
        this.loadTTC().then(() => {
          this.saveLoadingStep("Loading Complete");
          this.loadAnimEnd();
          this.ttcReady = true;
        });
      });
    }
    else{
      this.ttcReady = true;
    }
    this.setCollections();
    EventBus.$on("showOptions", (element) => {
      if (this.activeElement !== element && element !== null) {
        if (this.activeElement === null || this.activeElement === "null") {
          this.toggleOptionsPanel();
        }
        this.activeElement = element;
      } else {
        this.toggleOptionsPanel();
        this.activeElement = element;
      }
    });
    EventBus.$on("showDocumentsPanel", () => {
      if (!this.showDocumentsPanel) {
        this.toggleDocumentsPanel();
      }
    });
  },
  methods: {
    ...mapActions([
      "loadActiveElement",
      "saveFilterQuery",
      "saveDocPanelState",
      "loadCollectionDocs",
      "loadDocuments",
      "exportDocuments",
      "loadAnimStart",
      "loadAnimEnd",
      "saveLoadingStep",
      "loadTTC",
      "saveTtcState"
    ]),
    onCreated(wb) {
      console.log(wb);
    },
    setCollections() {
      this.options = [{ value: null, text: "Select Collection" }];
      _.each(this.collections, (coll) => {
        this.options.push({
          value: coll._id,
          text: coll.name,
        });
      });
    },
    getCollectionDocs() {
      this.loadCollectionDocs(this.selectedCollection);
    },
    setDefaults(defaults) {
      this.defaults = defaults;
    },
    updateSettings(settings) {
      this.quickSettings = settings;
    },
    removeBookmarks() {
      this.$refs.ttcTable.clearBookmarks();
    },
    clearSorting() {
      this.$refs.ttcTable.clearSorting();
    },
    resetStory() {
      this.$refs.ttcTable.clearLocalStorage();
    },
    clearDocFilter() {
      this.activeElement = null;
      this.showOptionsPanel = false;
      this.loadActiveElement({ element: null });
      this.saveFilterQuery({ query: [] });
    },
    updateDocPanel() {
      this.saveFilterQuery({ query: [] });
    },
    toggleOptionsPanel() {
      this.showOptionsPanel = !this.showOptionsPanel;
    },
    toggleLeftSidebar() {
      this.showLeftSidebar = !this.showLeftSidebar;
    },
    toggleTopPanel() {
      this.showTopPanel = !this.showTopPanel;
    },
    toggleDocumentsPanel() {
      this.showDocumentsPanel = !this.showDocumentsPanel;

      if (!this.showDocumentsPanel) {
        this.saveDocPanelState("default");
      }
    },
    resizeDocumentsPanel() {
      this.panelExpanded === "default"
        ? this.saveDocPanelState("expanded")
        : this.saveDocPanelState("default");
    },
    exportDocs() {
      this.docsLoading = !this.docsLoading;
      if (this.docsLoading) {
        /*this.loadDocuments({
          which: "global",
          page: 1,
          pageSize: this.documents.length,
          sortOn: "pubdate",
          sortAsc: false,
        }).then(() => {*/
          //this.exportDocuments(_.map(this.documents, "webkey")).then(() => {
          this.exportDocuments({ docs: _.map(this.documents, "webkey"), model: this.apiId }).then(() => {
            this.formatExportDocuments();
            this.exportReady = true;
          });
        //});
      } else {
        this.exportReady = false;
      }
    },
    getMetaValues(values) {
      const v = values.map((meta) => meta[0]);
      let metaVals = [];
      v.forEach((val) => {
        metaVals.push(val.name);
      });
      return metaVals.join(" | ");
    },
    async formatExportDocuments() {
      this.exportData = [];
      this.documentsExport.forEach((d) => {
        let text = {};
        let tempObj = {};
        d.text.forEach((t) => {
          tempObj[t.name] = t.text;
          text = { ...text, ...tempObj };
        });
        Object.entries(d.meta).forEach((entry) => {
          const [key, value] = entry;
          tempObj[key.split("_")[1]] = this.getMetaValues(value);
          text = { ...text, ...tempObj };
        });
        this.exportData.push(text);
      });
    },
    resetCollection() {
      this.selectedCollection = null;
    },
  },
};
</script>
